import { client, getUrl } from "utils";

export const metricGroupsRequest = (searchParams) => client.get(getUrl("metric-groups", searchParams));

export const metricGroupDeleteRequest = (code) => client.delete(`metric-group/${code}`);

export const getGroupRequest = (code) => client.get(`metric-group/${code}`);

export const editGroupRequest = (body) => client.put(`metric-group/${body.code}`, body);

export const createGroupRequest = (body) => client.post("metric-groups", body);
